import React from 'react'

import "./../assets/scss/Debug.scss";


export const Debug = (props) => {

    return(
        <div className="debug">
            <button className="red" onClick={() => props.onChangeRoom()}>+</button>
            <button className="red" onClick={() => props.onChangeRoom(-1)}>-</button>
            <button onClick={() => props.onChangeStep()}>+</button>
            <button onClick={() => props.onChangeStep(-1)}>-</button>
            <p><span className="red">room: {props.room}</span> - step: {props.step} - stepnow: {props.stepnow} - helpstate: {props.helpstate} - helpopen: {props.helpopen} - penality: {props.penality}</p>
        </div>
    )
}
